export default __webpack_public_path__ + "static/media/product16_slides.57b0c975.webp";